export default class ScrollPos {
	static top() {
		const { documentElement } = document;
		const { scrollTop, clientTop = 0 } = documentElement;
		const { pageYOffset } = window;

		const top = (pageYOffset || scrollTop) - clientTop;

		return top;
	}

	static left() {
		const { documentElement } = document;
		const { scrollLeft, clientLeft = 0 } = documentElement;
		const { pageXOffset } = window;

		const left = (pageXOffset || scrollLeft) - clientLeft;

		return left;
	}

	static get() {
		return { left: ScrollPos.left(), top: ScrollPos.top() };
	}
}
